/* eslint-disable react/jsx-props-no-spreading */
// https://swiperjs.com/react

/* eslint-disable react/prop-types */

import React, { useRef, useState } from "react";
import { PropTypes } from "prop-types";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css/bundle";

const SwiperCarousel = ({ _css, id, loop, options, nav, slides }) => {
  // ===========================================================================
  // context / ref / state

  const swiper = useRef(null);

  const [current, setCurrent] = useState(0);

  // ===========================================================================
  // methods

  const next = () => {
    if (swiper?.current?.swiper?.slideNext) {
      swiper.current.swiper.slideNext();
    }
  };

  const prev = () => {
    if (swiper?.current?.swiper?.slidePrev) {
      swiper.current.swiper.slidePrev();
    }
  };

  // ===========================================================================
  // render

  return (
    <>
      <Swiper
        id={id}
        ref={swiper}
        css={_css}
        loop={loop}
        onSlideChange={({ realIndex }) => {
          setCurrent(realIndex);
        }}
        {...options}
      >
        {slides.map((slide) => (
          <SwiperSlide>{slide}</SwiperSlide>
        ))}
      </Swiper>

      {nav &&
        nav({
          current,
          next,
          prev
        })}
    </>
  );
};

SwiperCarousel.defaultProps = {
  _css: [],
  id: `default-swiper`,
  loop: false,
  options: {
    spaceBetween: 0,
    slidesPerView: 1
  },
  slides: null
};
SwiperCarousel.propTypes = {
  _css: PropTypes.arrayOf(PropTypes.shape({})),
  id: PropTypes.string,
  loop: PropTypes.bool,
  options: PropTypes.shape({}),
  slides: PropTypes.arrayOf(PropTypes.shape({}))
};

export default SwiperCarousel;
